import script from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"

import "./TableGenerator.vue?vue&type=style&index=0&id=8fd9f34c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fd9f34c"]])

export default __exports__